import URI from 'urijs'

const compact = input =>
  Object.entries(input)
    .filter(([key, value]) => !!value)
    .reduce((acc, [key, value]) =>
      Object.assign(acc, { [key]: value }),
    {}
    )

/**
* @param {Object} oath2Redirect
* @param {string} oath2Redirect.domain Set to rails_app domain (required)
* @param {string} oath2Redirect.provider Set to provider name (required)
* @param {string} oath2Redirect.redirectUrl Set to the redirect url after oauth completes (required)
* @param {string} oath2Redirect.idToken Set to pass in an id token (used for cordova flow)
* @param {string} oath2Redirect.prompt Set to 'select_account' to force oauth to select account every time
* @param {string} oath2Redirect.provisioning Set to 'none' to disable account creation
* @param {string} oath2Redirect.role Set to 'participant' to sign up as participant (defaults to presenter if not included)
* @param {string} oath2Redirect.userSourceName Set to the user source name (see rails_app user_sources.yml for list)
* @param {string} oath2Redirect.tokenRequired Set to 'true' to call back with a pe_auth_token after login
* @param {string} oath2Redirect.platform Set to pass in the platform for mapping to OAuth client ID
* @param {string} oath2Redirect.firstName Set to the users firstName (if known) so we can prefill when signing up
* @param {string} oath2Redirect.lastName Set to the users lastName (if known) so we can prefill when signing up
*/
export default class Oauth2Redirect {
  constructor () {
    this.idToken = null
    this.prompt = null
    this.provider = null
    this.provisioning = null
    this.redirectUrl = null
    this.role = null
    this.userSourceName = null
    this.tokenRequired = null
    this.platform = null
    this.firstName = null
    this.lastName = null
  }

  get errors () {
    const requiredFields = [
      'domain',
      'provider',
      'redirectUrl',
      'platform'
    ]

    return requiredFields
      .filter(field => !this[field])
      .map(field => `this.${field} is required`)
  }

  get url () {
    if (this.errors.length) { return null }

    return URI(this.domain)
      .directory(`/oauth2/${this.provider}/redirect`)
      .query(
        compact({
          id_token: this.idToken,
          prompt: this.prompt,
          provisioning: this.provisioning,
          redirect: this.redirectUrl,
          role: this.role,
          usrc: this.userSourceName,
          token_required: this.tokenRequired,
          platform: this.platform,
          first_name: this.firstName,
          last_name: this.lastName
        })
      )
      .toString()
  }
}
